import ReactDom from 'react-dom' 
import App from './components/App/App.js'

ReactDom.render(<App/>, document.querySelector(".root"))